export default __webpack_public_path__ + "static/media/share-pin-hover.1196fe5a.svg";